import Vue from 'vue';

import App from './App.vue';
import router from './plugins/router';

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
